import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { Box } from 'UIKit/Grid';

import Panel from 'sama_global/components/Panel';

import {
  fetchParticipate,
  REQUEST_PARTICIPATE,
  fetchActiveOlimpics,
} from '@/modules/Olimpic';

import { useLoadbar } from 'sama_global/utils/hooks/loadbar';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';
import RenderSelectField from 'sama_global/components/RenderInput/RenderSelectField';
import { countries, useCategories } from 'sama_global/modules/olimpic';
import Form from 'sama_global/components/Form';
import { required } from '@/utils/Validate';
import Centrify from 'sama_global/components/Centrify';

const Olimpic = ({ requests, user, participate, olimpic, loadData }) => {
  const history = useHistory();

  const requestParticipate = requests[REQUEST_PARTICIPATE]; // TODO: сделать реквест отдельно

  const handleParticipate = async data => {
    await participate(olimpic?._id, data);
    await loadData();
    history.goBack();
  };

  const options = useCategories(user);

  const fields = [
    {
      name: 'category',
      locale: 'SELECT_CATEGORY',
      validate: [required],
      component: RenderSelectField,
      // info: 'OLIMPIC_CHOOSE_CATEGORY',
      options,
    },
    {
      name: 'country',
      locale: 'SELECT_COUNTRY',
      validate: [required],
      component: RenderSelectField,
      options: countries,
    },
  ];

  useLoadbar(REQUEST_PARTICIPATE);
  useSnackbarListener(requestParticipate?.errorMessage);

  return (
    <Centrify>
      <Box py={5} style={{ width: 400, margin: 'auto' }}>
        <Panel>
          <Box p={4}>
            {user.user._id && (
              <Form
                title="PARTICIPATE"
                fields={fields}
                onSubmit={handleParticipate}
                form="olimpic_participants_participate"
                initialValues={{
                  category: options[0].value,
                }}
              />
            )}
          </Box>
        </Panel>
      </Box>
    </Centrify>
  );
};

Olimpic.propTypes = {
  requests: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  olimpic: PropTypes.object.isRequired,
  participate: PropTypes.func.isRequired,
  loadData: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  requests: state.requests,
  user: state.user,
  olimpic: state.olimpic.sama || {},
});

const mapDispatchToProps = dispatch => ({
  participate(id, data) {
    return dispatch(fetchParticipate(id, data));
  },
  loadData() {
    dispatch(fetchActiveOlimpics());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Olimpic);
